var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"c-preloader"},[_c('div',{staticClass:"c-preloader__content"},[_c('div',{attrs:{"id":"loading-animation"}}),_c('div',{staticClass:"c-preloader__progress"},[_c('div',{staticClass:"c-preloader__progress-track",style:({width: `${_vm.loadingProgress}%`})})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }